import React from 'react';
import { Search } from 'lucide-react';
import CustomSelect from '../shared/CustomSelect';

const ProductFilters = ({
                            searchTerm,
                            onSearchChange,
                            selectedCompany,
                            onCompanyChange,
                            selectedType,
                            onTypeChange,
                            activeFilter,
                            onActiveFilterChange,
                            companies = [],
                            isDisabled = false  // Add prop to disable company filter
                        }) => {
    const productTypes = [
        { value: 'ALL', label: 'All Types' },
        { value: 'INSURANCE', label: 'Insurance' },
        { value: 'INVESTMENT', label: 'Investment' },
        { value: 'LOAN', label: 'Loan' },
        { value: 'SAVINGS', label: 'Savings' }
    ];

    const activeOptions = [
        { value: 'ALL', label: 'All Status' },
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' }
    ];

    const companyOptions = [
        { value: 'ALL', label: 'All Companies' },
        ...companies.map(company => ({
            value: company.id,
            label: company.name
        }))
    ];

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Search */}
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                        type="text"
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Company Filter - Disabled when filtering by specific company */}
                <CustomSelect
                    value={selectedCompany}
                    onChange={onCompanyChange}
                    options={companyOptions}
                    placeholder="All Companies"
                    disabled={isDisabled}
                    searchable
                />

                {/* Type Filter */}
                <CustomSelect
                    value={selectedType}
                    onChange={onTypeChange}
                    options={productTypes}
                    placeholder="All Types"
                />

                {/* Active Status Filter */}
                <CustomSelect
                    value={activeFilter}
                    onChange={onActiveFilterChange}
                    options={activeOptions}
                    placeholder="All Status"
                />
            </div>
        </div>
    );
};

export default ProductFilters;
